import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.concern-slider' ).length ) {
        $( '.concern-slider' ).each( function( index, element ) {
          const $imageSlider = $( element ).find( '.concern-slider__image-slider' );
          const $contentSlider = $( element ).find( '.concern-slider__content-slider' );

          if ( !$imageSlider.length || !$contentSlider.length ) return;

          const imageSplide = new Splide( $imageSlider[0], {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: false,
            drag: false,
          } );

          const contentSplide = new Splide( $contentSlider[0], {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: true,
            drag: false,
          } );

          contentSplide.sync( imageSplide );
          contentSplide.mount();
          imageSplide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'concern-slider', COMPONENT );
} )( app );
